import { UUID } from '../helpers';

export default {
  version: 4,
  primaryKey: 'id',
  properties: {
    id: {
      type: 'string',
      maxLength: UUID.maxLength,
      final: true
    },
    name: {
      type: 'string'
    },
    updatedAt: {
      type: 'integer'
    },
    lastSyncedAt: {
      type: ['integer', 'null']
    },
    active: {
      type: 'boolean',
      default: true
    },
    admin: {
      type: 'boolean',
      default: false
    },
    staff: {
      type: 'boolean',
      default: true
    }
  }
};
